import { combineReducers } from "redux";
import coreReducer from './core/reducer';
import serviceReducer from './service/reducer';
import accountReducer from './account/reducer';
import phoneReducer from './phone/reducer';

export default combineReducers({core : coreReducer,
                                service : serviceReducer,
                                phone : phoneReducer,
                                account : accountReducer});
                                

